import {createListResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const TransactionSchema = z.object({
  orderId: z.string().nullable(),
  date: z.string().nullable(),
  posNo: z.string().nullable(),
  type: z.any().nullable(),
  totalAmount: z.number().nullable(),
  paidAmount: z.number().nullable(),
  discountAmount: z.number().nullable(),
  channel: z.any().nullable(),
  storeNo: z.string().nullable(),
  transactionId: z.string().nullable(),
  memberId: z.string().nullable().optional(),
  memberName: z.string().nullable().optional(),
})

export const TransactionListSchemaResponse = createListResponseSchema(TransactionSchema.array())
export type TransactionItemList = z.infer<typeof TransactionListSchemaResponse.shape.response>

const filterListSchema = z.array(
  z.object({
    operator: z.number(),
    key: z.string(),
    value: z.array(z.string()),
    logicalOp: z.number().optional(),
    childFilters: z.array(z.object({})).optional(),
  })
)

const orderListSchema = z.array(
  z.object({
    type: z.number(),
    key: z.string(),
  })
)

const pagingSchema = z.object({
  currentPageNumber: z.number(),
  pageSize: z.number(),
})

const searchSchema = z.object({
  value: z.string(),
  keyList: z.array(z.string()),
})

export const listFilterSchema = z.object({
  filterList: filterListSchema,
  orderList: orderListSchema,
  paging: pagingSchema,
  search: searchSchema,
})

export type ListFilter = z.infer<typeof listFilterSchema>

export const PurchaseListSchema = z.object({
  memberId: z.string(),
  fullName: z.string(),
  status: z.number(),
  startDate: z.string().datetime(),
  endDate: z.string().datetime(),
})

export const PurchaseListSchemaResponse = createListResponseSchema(PurchaseListSchema.array())
export type PurchaseItemList = z.infer<typeof PurchaseListSchemaResponse.shape.response>

export const purchaseListFilterSchema = z.object({
  filterList: filterListSchema,
  orderList: orderListSchema,
  paging: pagingSchema,
  search: searchSchema,
})

export type PurchaseListFilter = z.infer<typeof purchaseListFilterSchema>
